import MasterRateClassListPage from './list/MasterRateClassListPage';

export default MasterRateClassListPage;
